import { Box, Typography } from "@mui/material";
import logo from "../assets/logo.png";

type WordmarkScale = "normal" | "huge";

export function Wordmark({ scale = "normal" }: { scale?: WordmarkScale }) {
  const logoSize = scale === "normal" ? 24 : 80;
  const typeVariant = scale === "normal" ? "h5" : "h1";
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        component="img"
        src={logo}
        alt="Doors"
        sx={{ width: logoSize, height: logoSize }}
      />

      <Typography
        variant={typeVariant}
        component="span"
        sx={{ fontWeight: 700, letterSpacing: "0.02em" }}
      >
        DOORS
      </Typography>
    </Box>
  );
}
